/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from '../../../components/ComponentSourcetitle';
import { ComponentPreloader } from '../../../components/ComponentPreloader';
import { useTableData } from '../data/useTableData';
import { useAgGridTransformer } from '../transformers/useAgGridTransformer';
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from '../../../../charts/components/HighchartsChart';
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useParameter } from "../../../shared";
import { useExportSource } from '../hooks/useExportSource';
import { ComponentTitle } from "../../../components/ComponentTitle";
import { Table } from "../../../components/Table";
import { debounceTime } from "rxjs/operators";

export const ComponentTable: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResultTable$.pipe<any>(debounceTime(300)));
  const highlight = useHookSubscribe(null, context.highlight$.pipe<any>(debounceTime(300)));

  const tableData = useTableData(olapResult);
  const agGridData = useAgGridTransformer(tableData, highlight);


  if (window['exportMode']) {
    window["exportReady"] = agGridData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (!agGridData || context.readyState === ComponentContextReadyState.Loading) {
    return <ComponentPreloader />;
  }

  return <>
    <ComponentTitle>Consumption per capita (kg/person)</ComponentTitle>
    <ComponentSourcetitle></ComponentSourcetitle>
    {agGridData ? <Table {...agGridData} /> : <ComponentPreloader />}
  </>
};
